import "./styles/import-progress.css";

/** Indeterminate until the server responds; never invent a completion percentage. */
export function ImportProgress({ label }: { label: string }) {
  return <div className="import-progress" role="status">
    <span>{label}</span>
    <progress aria-label={label} />
  </div>;
}
